<template>
  <div>
    <div class="nav-wrapper">
      <the-nav-bar title="" class="nav-bar" />
    </div>
    <div class="field">
      <div
        class="field-item row-justify-center"
        @click="isStartDatePickerShow = true"
      >
        <div class="field-item-title">{{ $t('orders.startingTime') }}</div>
        <div class="field-item-content">{{ startTime }}</div>
        <div class="field-item-right row-center">
          <md-icon name="arrow-right" size="sm" color="#84969C"></md-icon>
        </div>
      </div>
      <div
        class="field-item row-justify-center"
        @click="isEndDatePickerShow = true"
      >
        <div class="field-item-title">{{ $t('orders.endTime') }}</div>
        <div class="field-item-content">{{ endTime }}</div>
        <div class="field-item-right row-center">
          <md-icon name="arrow-right" size="sm" color="#84969C"></md-icon>
        </div>
      </div>
    </div>
    <md-date-picker
      ref="startDatePicker"
      v-model="isStartDatePickerShow"
      :title="$t('orders.startingTimeTips')"
      :default-date="startDefaultDate"
      :min-date="new Date('2021/10/1')"
      :max-date="new Date()"
      :key="`start_${startTimeKey}`"
      :cancel-text="$t('common.cancel')"
      :ok-text="$t('common.confirm')"
      :text-render="textRender"
      @confirm="onStartDatePickerConfirm"
    ></md-date-picker>
    <md-date-picker
      ref="endDatePicker"
      v-model="isEndDatePickerShow"
      :title="$t('orders.endTimeTips')"
      :default-date="endDefaultDate"
      :min-date="new Date('2021/10/1')"
      :max-date="new Date()"
      :key="`end_${endTimeKey}`"
      :cancel-text="$t('common.cancel')"
      :ok-text="$t('common.confirm')"
      :text-render="textRender"
      @confirm="onEndDatePickerConfirm"
    ></md-date-picker>
  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import { TabBar, Icon, DatePicker } from 'mand-mobile';
import noSci from '@/utils/no-sci.js';
import { mapState } from 'vuex';
export default {
  components: {
    TheNavBar,
    [TabBar.name]: TabBar,
    [Icon.name]: Icon,
    [DatePicker.name]: DatePicker,
  },
  filters: {
    noSci,
  },
  data() {
    return {
      startTime: '',
      endTime: '',
      isStartDatePickerShow: false,
      isEndDatePickerShow: false,
      startDefaultDate: new Date(),
      endDefaultDate: new Date(),
      startTimeKey: '',
      endTimeKey: '',
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    };
  },
  computed: {
    ...mapState(['navLang']),
    lineHeight() {
      const width = document.documentElement.clientWidth || window.innerWidth;
      return Math.round((width / 100) * 6.4);
    },
  },
  beforeRouteLeave(to, from, next) {
    // ...
    this.$store.commit('setOrderTemp', {
      startTime: this.startTime,
      endTime: this.endTime,
    });
    next();
  },
  mounted() {
    this.startTime = this.$store.state.orderTempState.startTime;
    this.endTime = this.$store.state.orderTempState.endTime;
    this.startDefaultDate = new Date(this.startTime);
    this.endDefaultDate = new Date(this.endTime);
  },
  methods: {
    onStartDatePickerConfirm() {
      this.startTime = this.$refs.startDatePicker.getFormatDate('yyyy/MM/dd');
      this.startDefaultDate = new Date(this.startTime);
      this.startTimeKey = new Date().getTime();
      this.isStartDatePickerShow = false;
    },
    onEndDatePickerConfirm() {
      this.endTime = this.$refs.endDatePicker.getFormatDate('yyyy/MM/dd');
      this.endDefaultDate = new Date(this.endTime);
      this.endTimeKey = new Date().getTime();
      this.isEndDatePickerShow = false;
    },
    textRender() {
      if (this.navLang === 'en') {
        const args = Array.prototype.slice.call(arguments);
        const typeFormat = args[0];
        if (typeFormat === 'yyyy' && args[1]) {
          return args[1];
        }
        if (typeFormat === 'MM' && args[2]) {
          return this.months[args[2] - 1];
        }
        if (typeFormat === 'dd' && args[3]) {
          return args[3];
        }
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.nav-wrapper {
  background: #fff;

  .md-tab-bar {
    margin-top: 2.13vw;

    & >>> {
      .md-tab-bar-item {
        font-weight: normal;

        &.is-active {
          font-weight: bold;
        }
      }
    }
  }
}

.body-wrapper {
  position: absolute;
  // absolute-pos(25.6vw);
  absolute-pos(52vw);
  background: #F8FBFC;
}

.field {
  padding: 6.4vw 0;

  .field-item {
    padding: 0 4.8vw;
    height: 17.07vw;
    font-size: 3.73vw;

    &:nth-child(even) {
      background: #f8fbfc;
    }

    .field-item-title {
      flex: 0 0 32vw;
      font-weight: bold;
    }

    .field-item-content {
      width: 58.4vw;
      text-align: right;
      color: #1b6fdc;
      word-ellipsis();

      &.inactive {
        color: #bcc7cb;
      }
    }
  }
}

.md-date-picker >>> .column-item {
  font-size: 3.73vw !important;
}
</style>

<style>
.md-picker-column-item .column-list .column-item.active {
  color: #1b6fdc !important;
}
ul li {
  list-style: none;
}
.md-picker-column-container .top {
  height: 0px !important;
}
.md-picker-column-container .bottom {
  height: 0px !important;
}
</style>
